export async function saveAreaLocation_rh(coordinates: number[][][], area: number, name: string) {
  const payload = {
    coordinates,
    area,
    name,
  };

  const res = await fetch(`/api/skywatch/locations`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
  });
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  if (response?.errors) {
    return { error: response.errors[0]?.message };
  }

  return response?.data;
}

export async function getAreaLocations_rh(cursor: string | null) {
  const res = await fetch(`/api/skywatch/locations${cursor ? `?cursor=${cursor}` : ''}`);
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  if (response?.data?.errors) {
    return { error: response?.data?.errors[0].message, data: null, next: null };
  }

  const data = response.data?.filter((value: any) => !value?.is_deleted);

  return { data, next: response?.pagination?.cursor?.next, error: null };
}

export async function getAreaLocationCoordinates_rh(locationId: string) {
  const res = await fetch(`/api/skywatch/locations/${locationId}`);
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  if (response?.data?.errors) {
    return { error: response?.data?.errors[0].message };
  }

  return response?.data?.aois?.features[0].geometry.coordinates;
}

export async function renameSavedArea_rh(locationId: string, name: string) {
  const res = await fetch(`/api/skywatch/locations/${locationId}`, {
    method: 'PATCH',
    body: JSON.stringify({ name }),
    headers: { 'Content-Type': 'application/json' },
  });
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  if (response?.errors) {
    return { error: response?.errors[0].message };
  }

  return response;
}

export async function deleteSavedArea_rh(locationId: string) {
  const res = await fetch(`/api/skywatch/locations/${locationId}`, {
    method: 'DELETE',
  });
  const rhResponse: { json: any; status: number } = await res.json();
  const response = rhResponse?.json;

  if (response?.errors) {
    return { error: response?.errors[0].message };
  }

  return response;
}
